var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("table", { staticClass: "table is-fullwidth is-narrow" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm.organizaciones && _vm.organizaciones.length > 0
            ? _c(
                "tbody",
                _vm._l(_vm.organizaciones, function (org) {
                  return _c("tr", { key: org.id, attrs: { id: org.id } }, [
                    _c(
                      "td",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "organizacionInfo",
                                params: { idOrganization: org.id },
                              },
                            },
                          },
                          [_vm._v(_vm._s(org.razon_social))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\r\n            " + _vm._s(org.cuit) + "\r\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\r\n            " +
                          _vm._s(org.email) +
                          "\r\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "field has-addons is-pulled-right" },
                        [
                          _c(
                            "p",
                            { staticClass: "control" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "button is-white is-small",
                                  attrs: {
                                    to: {
                                      name: "organizacionInfo",
                                      params: { idOrganization: org.id },
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-eye fa-lg fa-fw",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "control" },
                            [
                              _c(
                                "router-link",
                                {
                                  staticClass: "button is-white is-small",
                                  attrs: {
                                    to: {
                                      name: "organizacionEditar",
                                      params: { idOrganization: org.id },
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-edit fa-lg fa-fw",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "control" },
                            [
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    "aria-role": "list",
                                    position: "is-bottom-left",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "trigger",
                                        fn: function ({ active }) {
                                          return [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "button is-white is-small",
                                                attrs: {
                                                  "aria-haspopup": "true",
                                                  "aria-controls":
                                                    "dropdown-menu",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                    Más "
                                                ),
                                                _c("i", {
                                                  staticClass: "fas fa-fw",
                                                  class: active
                                                    ? "fa-angle-up"
                                                    : "fa-angle-down",
                                                }),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        "aria-role": "listitem",
                                        "has-link": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            to: {
                                              name: "organizacionUsuarios",
                                              params: {
                                                idOrganization: org.id,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                      Usuarios\r\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        "aria-role": "listitem",
                                        "has-link": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            to: {
                                              name: "organizacionAreas",
                                              params: {
                                                idOrganization: org.id,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                      Areas\r\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-dropdown-item",
                                    {
                                      attrs: {
                                        "aria-role": "listitem",
                                        "has-link": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "dropdown-item",
                                          attrs: {
                                            to: {
                                              name: "organizacionModulos",
                                              params: {
                                                idOrganization: org.id,
                                              },
                                            },
                                            exact: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\r\n                      Módulos\r\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                0
              )
            : _vm.organizaciones && _vm.organizaciones.length == 0
            ? _c("tbody", [
                _vm.loading
                  ? _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass: "has-text-centered",
                          attrs: { colspan: "4" },
                        },
                        [_c("loading-spin")],
                        1
                      ),
                    ])
                  : _c("tr", [_vm._m(2)]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("paginator", {
          attrs: { resource: _vm.url, loading: _vm.loading },
          on: {
            update: _vm.updateResource,
            "update:loading": function ($event) {
              _vm.loading = $event
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Organizaciones")]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Listado")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Razón")]),
        _vm._v(" "),
        _c("th", [_vm._v("CUIT")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email")]),
        _vm._v(" "),
        _c(
          "th",
          { staticClass: "has-text-right", attrs: { width: "200px;" } },
          [_vm._v("Acciones")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      { staticClass: "has-text-centered is-mono", attrs: { colspan: "4" } },
      [_c("i", [_vm._v("Sin organizaciones para mostrar")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }